import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpHeadersPortal, HttpService } from '../../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class CertificatesService {
  private url;
  private headers: HttpHeadersPortal;

  constructor(private httpService: HttpService) {
    this.conectionConfig();
  }

  private conectionConfig(): void {
    this.headers = {
      CACHE_CONTROL: 'no-cache no-store',
      EXPIRES: '0',
      PRAGMA: 'no-cache'
    }

    this.url = environment.AFILIACION.CERTIFICADOS_API;
  }

  affiliationPerson(datePerson: any) {
    return this.httpService.post<any>(
      this.url,
      '/afiliado/persona',
      datePerson
    );
  }

  affiliationCompany(dateCompany: any) {
    return this.httpService.post<any>(
      this.url, 
      '/afiliado/empresa',
      dateCompany);
  }

  downloadCertificate(dataCompany: any, type: string): Observable<any> {
    let endpoint = '/afiliado/empresa';
    
    if (type === 'PERSON') {
      endpoint = '/afiliado/persona';
    }

    return this.httpService.post<any>(
      this.url,
      endpoint,
      dataCompany
    ).pipe(
        map(res => {
          const auxLink = document.createElement('a');
          auxLink.setAttribute("display","none");
          auxLink.style.display = "none";
          auxLink.setAttribute("aria-label", "true");
          auxLink.innerHTML = "Archivo descargado";
          auxLink.setAttribute("id", "idDownLoad_Certificado");
          auxLink.setAttribute("alt", "Archivo descargado");
          document.body.appendChild(auxLink);
          const url = `data:application/pdf;base64,${res.body}`;
          auxLink.href = url;
          auxLink.target = '_blank';
          auxLink.hidden = true;
          auxLink.setAttribute("aria-label", "true");
          auxLink.download = 'certificado de afilicacion';
          auxLink.click();
          window.URL.revokeObjectURL(url);
        })
      );
  }
  
  downloadCertificateWindow(dataCompany: any, type: string) {
    let urlApi = '/afiliado/empresa';
    
    if (type === 'PERSON') {
      urlApi = '/afiliado/persona';
    }

    if (type === 'PERSON') {
      return this.httpService.post<any>(
        this.url,
        urlApi,
        dataCompany
      ).pipe(
          map(res => {
            const url = `data:application/pdf;base64,${res.body}`;
            const pdfResult = res.body;
            const pdfWindow = window.open('');
            pdfWindow.document.write('<iframe width=\'100%\' height=\'100%\' style=\'border: 0; margin:-10px;\' src=\'data:application/pdf;base64, ' + encodeURI(pdfResult) + '\'></iframe>');
          }),
        );
    } else if (type === 'COMPANY') {
      return this.httpService.post<any>(
        this.url, 
        urlApi, 
        dataCompany, 
        {},
        this.headers
      )
        .pipe(
          map(res => {
            const url = `data:application/pdf;base64,${res.body}`;
            const pdfResult = res.body;
            const pdfWindow = window.open('');
            pdfWindow.document.write('<iframe width=\'100%\' height=\'100%\' style=\'border: 0; margin:-10px;\' src=\'data:application/pdf;base64, ' + encodeURI(pdfResult) + '\'></iframe>');
          })
        );
    }
  }
}
